export class VisitorProfileCache {
    _sdkConfig;
    constructor(sdkConfig) {
        this._sdkConfig = sdkConfig;
    }
    saveVisitorProfile() {
        //
    }
    loadVisitorProfile() {
        //
        return null;
    }
}
